import {
    RANKS_FAILURE,
    RANKS_REQUEST,
    RANKS_SUCCESS,
} from 'actions';
import preserveArrayReference from 'utils/Array/preserveArrayReference';

const initialState = {
    data: [],
    isFetched: false,
    isFetching: false,
};

export const rankListReducer = (state = initialState, action) => {
    const {type, data} = action;
    switch (type) {
        case RANKS_SUCCESS: {return {
            ...state,
            isFetched: true,
            isFetching: false,
            data: preserveArrayReference(state.data, data),
        }}

        case RANKS_REQUEST: {return {
            ...state,
            isFetching: true,
        }}

        case RANKS_FAILURE: {return {
            ...state,
            isFetching: false,
        }}

        default: {return state}
    }
};
